import { CONTRACTOR_AFFILIATION_PREFERENCES } from '@lp/features/admin/forms/ContractorForm/types';
import { SelectItemType } from '@/types';
import { ResourceFilters, SURGEON_TYPE_LABELS, SurgeonType, surgeonTypeItems } from '../../config';
import { LocationPreference } from '@/api/apis/resources';

export const getFilterTitle = (items: SelectItemType[], selectedKey: string) => {
  return items.find((i) => i.value === selectedKey)?.name ?? '';
};

const getFilterTitleByKey = (filterValue: string | undefined, options: SelectItemType[], fallback: string): string => {
  return filterValue ? options.find((opt) => opt.value === filterValue)?.name || fallback : fallback;
};

export const getAffiliationFilterTitle = (filters: ResourceFilters) =>
  getFilterTitleByKey(filters.surgeonType[0], surgeonTypeItems, SURGEON_TYPE_LABELS[SurgeonType.Employee]);

export const getAffiliationTypeFilterTitle = (filters: ResourceFilters) =>
  getFilterTitleByKey(filters.affiliationType?.[0], CONTRACTOR_AFFILIATION_PREFERENCES, LocationPreference.Affiliation);
